import React from 'react';
import './alert.css';
import { Dialog, DialogContent } from '@material-ui/core';
import { hideAlert } from 'store/alert';
import { Typography, Loader } from 'components';
import { useSelector } from 'react-redux';
import { useReduxDispatch } from 'store/hooks';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  iconContainer: {
    width: 48,
    height: 48,
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '0px 15px 0px 30px',
    backgroundColor: '#1ab7a7'
  },
  iconContainer2: {
    width: 48,
    height: 48,
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#fc0000'
  },
  rootContent: {
    width: 536,
    height: 104,
    backgroundColor: '#def9f6',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderRadius: 8,
    marginBottom: 20
  },
  rootErrorContent: {
    width: 536,
    height: 104,
    backgroundColor: '#ffe9e8',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 8,
    flexDirection: 'column'
  },
  rootItem: {
    width: '100%',
    border: 'solid 1px #e6e6e6',
    borderRadius: 4,
    height: 80,
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#f2f2f2'
    }
  },
  containerItem: {
    width: 'calc(100% - 24px)',
    padding: '0px 12px',
    display: 'flex',
    justifyContent: 'space-between'
  },
  link: {
    textDecoration: 'none'
  },
  dialogContent: {
    paddingBottom: 20,
    paddingTop: 20
  }
}))

const SuccessAnimation2 = () => (
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2" width={36}>
    <circle className="path circle" fill="none" stroke="#FFFFFF" strokeWidth="7" strokeMiterlimit="10" cx="66" cy="66" r="50"/>
    <rect width={40} height={40} y={20} x={75} fill='#1ab7a7'/>
    <polyline className="path check" fill="none" stroke="#FFFFFF" strokeWidth="7" strokeLinecap="round" strokeMiterlimit="10" points="120.2,20.2 65.5,88.8 45.8,67.5 "/>
  </svg>
);

const ErrorAnimation2 = () => (
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2" width={36}>
    <circle className="path circle" fill="none" stroke="#FFFFFF" strokeWidth="6" strokeMiterlimit="10" cx="65.1" cy="65.1" r="62.1"/>
    <line className="path line" fill="none" stroke="#FFFFFF" strokeWidth="6" strokeLinecap="round" strokeMiterlimit="10" x1="34.4" y1="37.9" x2="95.8" y2="92.3"/>
    <line className="path line" fill="none" stroke="#FFFFFF" strokeWidth="6" strokeLinecap="round" strokeMiterlimit="10" x1="95.8" y1="38" x2="34.4" y2="92.2"/>
  </svg>
)

const getStatus = ({ status, ...props }) => ({
  isOpen: status !== 'hide',
  isWaiting: status === 'waiting',
  isSuccess: status === 'success',
  isError: status === 'error',
  status,
  ...props
})

const Alert = (props) => {
  const classes = useStyles();
  const _hideAlert = useReduxDispatch(hideAlert);
  const alert = getStatus(useSelector(state => state.alert));

  const AlertSuccess = ({ message }) => (
    <div style={{ width: 546 }}>
      <div className={classes.rootErrorContent} style={{ backgroundColor: '#def9f6' }}>
        <div className={classes.iconContainer2} style={{ backgroundColor: '#1ab7a7' }}>
          <SuccessAnimation2 />
        </div>
        <Typography type='bold' color='#1ab7a7'>{message}</Typography>
      </div>
    </div>
  )

  const AlertError = ({ message }) => (
    <div style={{ width: 546 }}>
      <div className={classes.rootErrorContent}>
        <div className={classes.iconContainer2} >
          <ErrorAnimation2 />
        </div>
        <Typography type='bold' color='#fc0000'>{message}</Typography>
      </div>
    </div>
  )

  const AlertWaiting = ({ message }) => (
    <div style={{ width: 546 }}>
      <div className={classes.rootErrorContent} style={{ backgroundColor: '#fff6e8' }}>
        <div className={classes.iconContainer2} style={{ backgroundColor: '#fc9700' }}>
          <Loader variant="grid" color='#FFFFFF' />
        </div>
        <Typography type='bold' color='#fc9700'>{message}</Typography>
      </div>
    </div>
  )

  return (
    <Dialog
      open={alert.isOpen}
      onClose={alert.isWaiting ? () => {} : _hideAlert}
      maxWidth='md'
    >
      <DialogContent style={{ overflowY: 'hidden' }}>
        {alert.isWaiting && <AlertWaiting message={alert.message}/>}
        {alert.isSuccess && <AlertSuccess message={alert.message}/>}
        {alert.isError && <AlertError message={alert.message}/>}
      </DialogContent>
    </Dialog>
  )
}

export default Alert;
